import React, { Fragment } from 'react'

import { graphql } from 'gatsby'

import Container from '../components/Container'

import SEO from '../components/SEO'
import { startCase } from 'lodash'
import { Heading } from 'theme-ui'
import ContentfulRichText from '../components/shared/Contentful/RichText'
import { BLOCKS } from '@contentful/rich-text-types'
import Body from '../components/shared/Typography/Body/Body'

const options = {
  [BLOCKS.HEADING_1]: (node, children) => (
    <Heading as="h4" sx={{ my: 30, mb: 40 }}>
      {children}
    </Heading>
  ),
  [BLOCKS.HEADING_2]: (node, children) => (
    <Heading as="h5" sx={{ my: 20 }}>
      {children}
    </Heading>
  ),
  [BLOCKS.PARAGRAPH]: (node, children) => (
    <Body variant="body2" sx={{ mb: 25 }}>
      {children}
    </Body>
  ),
}

const Policy = ({ data, pageContext }) => {
  const { body, title, slug } = data.contentfulPolicy

  return (
    <Fragment>
      <SEO title={startCase(slug)} />
      <Container>
        <ContentfulRichText customOptions={options} text={body} />
      </Container>
    </Fragment>
  )
}

export default Policy

export const query = graphql`
  query($slug: String!) {
    contentfulPolicy(slug: { eq: $slug }) {
      body {
        raw
      }
      slug
      title
    }
  }
`
